import { Stack, Typography, FormControlLabel, Switch } from '@mui/material';
import useIsMobile from 'hooks/useIsMobile';
import SettingsPopout from '../../shared/SettingsPopout';
import { useTotalOIPutCallImpactCtx } from './useTotalOIPutCallImpactCtx';

export const TotalOIPutCallImpactSettings = () => {
  const isMobile = useIsMobile();
  const { config, updateConfig } = useTotalOIPutCallImpactCtx();

  return (
    <SettingsPopout
      title="Put/Call Impact Settings"
      popperID="total-oi-pc-impact-controls"
      placement="bottom-end"
      sx={{
        width: isMobile ? '280px' : '400px',
      }}
    >
      <Stack sx={{ gap: '8px' }}>
        <FormControlLabel
          control={
            <Switch
              checked={config.showKeyLevels}
              onChange={(_e, checked: boolean) =>
                updateConfig({ showKeyLevels: checked })
              }
            />
          }
          label={<Typography>Show key levels</Typography>}
          labelPlacement="end"
        />
      </Stack>
    </SettingsPopout>
  );
};
